function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "academic_excellence",
  transform: "translate(-1200.496 -840)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "base",
  width: 56,
  height: 56,
  transform: "translate(1200.496 840)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "academic_excellence-2",
  transform: "translate(1203.908 844)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_60963",
  d: "M44.021,2,39.133,7.93h-26.4L7.8,2Z",
  transform: "translate(-1.325 -0.281)",
  fill: "#ffe5ef"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60966",
  d: "M44.737,8.732l-19.791,24L5,8.732a3.923,3.923,0,0,1,.327-5.379L6.758,2,24.946,23.877,42.979,2,44.41,3.353A3.932,3.932,0,0,1,44.737,8.732Z",
  transform: "translate(-0.28 -0.281)",
  fill: "#ffe5ef"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60970",
  d: "M38.9,46.707A9.7,9.7,0,1,1,29.206,37,9.7,9.7,0,0,1,38.9,46.707Z",
  transform: "translate(-4.615 -10.125)",
  fill: "#ff0660"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60974",
  d: "M35.72,44.29a6.331,6.331,0,0,0-3.7-1.186,6.407,6.407,0,0,0-5.225,10.12A6.408,6.408,0,1,1,35.72,44.29Z",
  transform: "translate(-5.904 -11.413)",
  fill: "#f5f5f7",
  opacity: 0.4
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60975",
  d: "M25.725,52.151a6.331,6.331,0,0,0,3.7,1.186,6.407,6.407,0,0,0,5.225-10.12,6.408,6.408,0,1,1-8.927,8.934Z",
  transform: "translate(-6.366 -11.874)",
  fill: "#000040",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_31394",
  transform: "translate(3.091 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_60976",
  d: "M38.528,9.25H19.582a.719.719,0,1,0,0,1.437H38.528a.719.719,0,1,0,0-1.437Z",
  transform: "translate(-7.527 -3.32)",
  fill: "#000072"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60977",
  d: "M44.627,2.547,43.2,1.2a.8.8,0,0,0-.5-.2H6.478A.736.736,0,0,0,6,1.184c-.006.005-.013.007-.019.012L4.554,2.547a4.662,4.662,0,0,0-.39,6.365L17.088,24.459a.718.718,0,1,0,1.1-.919L5.269,7.993a3.223,3.223,0,0,1,.272-4.4l.873-.825,17.7,21.289a.718.718,0,0,0,.552.259.666.666,0,0,0,.555-.261L42.768,2.769l.872.824A3.223,3.223,0,0,1,43.9,8L31.086,23.542a.719.719,0,0,0,1.109.915L45.008,8.913A4.661,4.661,0,0,0,44.627,2.547ZM24.667,22.47,8.01,2.437H41.171Z",
  transform: "translate(-3.091 -1)",
  fill: "#000072"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60978",
  d: "M34.249,37.482c2.325.038,2.753-.052,2.753-.763A.719.719,0,0,0,36.284,36H21.557a.719.719,0,0,0,0,1.437c.762-.016,1.481-.027,2.17-.037a10.422,10.422,0,1,0,10.522.08ZM28.925,55.406a8.984,8.984,0,1,1,8.979-8.98A8.995,8.995,0,0,1,28.925,55.406Z",
  transform: "translate(-7.424 -10.844)",
  fill: "#000072"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60979",
  d: "M30.213,40.583a7.128,7.128,0,1,0,7.124,7.131A7.139,7.139,0,0,0,30.213,40.583Zm0,12.818A5.69,5.69,0,1,1,35.9,47.714,5.7,5.7,0,0,1,30.213,53.4Z",
  transform: "translate(-8.714 -12.133)",
  fill: "#000072"
}))));

function SvgAcademicExcellence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademicExcellence);
export default __webpack_public_path__ + "static/media/academic_excellence.423673ee.svg";
export { ForwardRef as ReactComponent };